import "csi/action/_base";
import "csi/def/ActionWithValidation";
import "csi/def/Type";
import "csi/dojoExtensions";
import "csi/heading/_base";
import "csi/heading/Aggregate";
import "csi/heading/Container";
import "csi/view/_base";
import React from "react";
import "temporal-polyfill/global";

type CallbackFunction = () => Promise<void> | void;

let _breadcrumbChangeFunction: CallbackFunction | undefined;
let _refreshFunction: CallbackFunction | undefined;
let _resizeFunction: CallbackFunction | undefined;

document.documentElement.classList.toggle("dj_edge", /Edg/.test(navigator.userAgent));

// Making React available to the global scope so that it can be used by centricsoftware/modelViewer
globalThis.React = React;

const moduleExports = {
	/**
	 * Render new version of breadcrumb view (not the content view)
	 * @return {Promise<void>}
	 */
	refreshRootView(): Promise<void> | void {
		return _breadcrumbChangeFunction?.();
	},

	/**
	 * Force redraw UI
	 * @return {Promise<void>}
	 */
	refreshViews(): Promise<void> | void {
		return _refreshFunction?.();
	},

	/**
	 * Force resize of UI
	 */
	resize(): void {
		_resizeFunction?.();
	},

	/**
	 * Set callback function to use when Set callback to respond to changes in breadcrumb trail
	 * @param {CallbackFunction} callback
	 */
	setBreadcrumbChangeHandler(callback: CallbackFunction): void {
		_breadcrumbChangeFunction = callback;
	},

	/**
	 * Set callback function to use when required to refresh all page views
	 * @param {CallbackFunction} callback
	 */
	setRefreshHandler(callback: CallbackFunction): void {
		_refreshFunction = callback;
	},

	/**
	 * Set callback function to use when required to resize all page views
	 * @param {CallbackFunction} callback
	 */
	setResizeHandler(callback: CallbackFunction): void {
		_resizeFunction = callback;
	},
};

export = moduleExports;